import { StyleSheet } from 'react-native';
import { LILAC_300, tokens } from '../../constants';
import { checkIsPlatform } from '../../utils';
var spacing = tokens.spacing;
export var getTopNavStyles = () => {
  return StyleSheet.create({
    topNavContainer: {
      position: checkIsPlatform('web') ? 'sticky' : 'absolute',
      top: 0,
      right: 0,
      left: 0,
      flexDirection: 'row',
      backgroundColor: LILAC_300,
      alignItems: 'center',
      paddingHorizontal: spacing.SPACING_20,
      paddingVertical: spacing.SPACING_16,
      zIndex: 1000
    },
    topNavLeftButton: {
      flex: 2,
      flexDirection: 'row',
      justifyContent: 'flex-start'
    },
    topNavCenter: {
      flex: 6,
      flexShrink: 1,
      flexDirection: 'column',
      alignItems: 'center'
    },
    topNavRightButton: {
      flex: 2,
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  });
};